/** Shared delete-account copy — Data Tier 1 wipe only; Tier 2 client files untouched. */

export const DELETE_ACCOUNT_WARNING =
  "This action is permanent. Once confirmed, all of your Mentology AI-Mentor data — configuration, task history, and ledger records — will be immediately and irreversibly deleted from Mentology's systems. This cannot be undone, and Mentology cannot recover or restore this data for you under any circumstances, for any reason. Your business files are not affected — they remain in your own connected cloud storage.";

export const DELETE_ACCOUNT_TYPE_PROMPT =
  'Type DELETE to confirm permanent account deletion.';

export const DELETE_ACCOUNT_SUCCESS_MESSAGE =
  'Your Mentology account data has been erased. Business files in your own cloud storage were never held by Mentology.';

/** Two-step confirm: warning dialog, then exact DELETE typed in a prompt. */
export function confirmDeleteAccount(): boolean {
  if (!window.confirm(DELETE_ACCOUNT_WARNING)) return false;
  const typed = window.prompt(DELETE_ACCOUNT_TYPE_PROMPT);
  return typed?.trim() === 'DELETE';
}
